/*
 * Author: Danny Ehlers
 * Date: 8/16/2018
 * A custom module for a global spinner that can be imported into any Angular 5+ project.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtomSpinnerModule, TrinityRingsSpinnerModule } from 'angular-epic-spinners'
import { CapSpinnerComponent } from './cap-spinner/cap-spinner.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CapSpinnerHttpInterceptorService } from './cap-spinner/services/cap-spinner-http-interceptor.service';
import { CapHttpInterceptorService } from './services/cap-http-interceptor.service';

@NgModule({
  imports: [
    CommonModule,
    AtomSpinnerModule
  ],
  declarations: [
    CapSpinnerComponent
  ],
  exports: [
    CapSpinnerComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CapSpinnerHttpInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CapHttpInterceptorService,
      multi: true
    }
 ]
})
export class CoreModule { }
